module.exports = __webpack_public_path__ + "static/img/PM.24fd396f.svg";